<app-load-dropdown-data [formName]="formName" (fillDropdownData)="fillDropdownData()"></app-load-dropdown-data>
<div class="container-fluid d-flex flex-column h-100 px-0">
  <div class="row mx-0 gap-2 d-flex flex-column h-100 py-2">
      <div class="col flex-fill h-0 p-0">
        <app-ag-grid
          [dataModel]="agGridDataModel" 
          [columnSettings]="true"
          (gridReady)="onGridReady($event)"
          (onTextCellClick) = "handleTextClick($event)"
          (onSortIconClick)="onSortIconClick($event)"
          (onPagination)="onPagination($event)"
         ></app-ag-grid>
        </div>
  </div>
  <hr class="mt-2 border-gray-1">
</div>
